module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<li class="hotel-detail-item">\r\n    <label class="hotel-detail-label">\r\n        <img src="https://qnb.oss-cn-shenzhen.aliyuncs.com/real_1749462714946.png" alt="" style="float: left;margin-right: 10px;" />\r\n        入住政策\r\n    </label>\r\n\r\n    <div style="margin-left: 140px;padding-bottom: 5px;border-bottom: dashed 1px #e3e3e3;">\r\n        <div style="margin-bottom: 10px;">\r\n            <span style="font-weight: 600;">入住离店时间:</span>\r\n            <div >\r\n                ';
 if (o.arriveStartTime && o.arriveEndTime){ ;
__p += '\r\n                <p >\r\n                    酒店入住开始时间' +
((__t = ( o.arriveStartTime )) == null ? '' : __t) +
'，结束时间' +
((__t = ( o.arriveEndTime )) == null ? '' : __t) +
'\r\n                </p>\r\n                ';
 } ;
__p += '\r\n\r\n                ';
 if (o.addAttrMap && o.addAttrMap.checkOutTime){ ;
__p += '\r\n                <p >\r\n                    酒店退房时间' +
((__t = ( o.addAttrMap.checkOutTime )) == null ? '' : __t) +
'\r\n                </p>\r\n                ';
 } ;
__p += '\r\n            </div>\r\n        </div>\r\n\r\n        ';
 if (o.policies){ ;
__p += '\r\n        <div style="margin-bottom: 10px;">\r\n            <span style="font-weight: 600;">入住政策：</span>\r\n            <div>' +
((__t = ( o.policies )) == null ? '' : __t) +
'</div>\r\n        </div>\r\n        ';
 } ;
__p += '\r\n\r\n        ';
 if (o.checkInInstructions){ ;
__p += '\r\n        <div style="margin-bottom: 10px;">\r\n            <span style="font-weight: 600;">入住提示：</span>\r\n            <div>' +
((__t = ( o.checkInInstructions )) == null ? '' : __t) +
'</div>\r\n        </div>\r\n        ';
 } ;
__p += '\r\n\r\n        ';
 if (o.specialCheckInInstructions){ ;
__p += '\r\n        <div style="margin-bottom: 10px;">\r\n            <span style="font-weight: 600;">特殊入住提示：</span>\r\n            <div>' +
((__t = ( o.specialCheckInInstructions )) == null ? '' : __t) +
'</div>\r\n        </div>\r\n        ';
 } ;
__p += '\r\n\r\n        ';
 if (o.addAttrMap && o.addAttrMap.fees_mandatory){ ;
__p += '\r\n        <div style="margin-bottom: 10px;">\r\n            <span style="font-weight: 600;">强制性费用：</span>\r\n            <div>' +
((__t = ( o.addAttrMap.fees_mandatory )) == null ? '' : __t) +
'</div>\r\n        </div>\r\n        ';
 } ;
__p += '\r\n\r\n        ';
 if (o.addAttrMap && o.addAttrMap.fees_optional){ ;
__p += '\r\n        <div style="margin-bottom: 10px;">\r\n            <span style="font-weight: 600;">可选项费用：</span>\r\n            <div>' +
((__t = ( o.addAttrMap.fees_optional )) == null ? '' : __t) +
'</div>\r\n        </div>\r\n        ';
 } ;
__p += '\r\n        \r\n    </div>\r\n</li>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/common/hotelPriceUtil/templates/hotelPolicyTmpl.ejs
// module id = 158
// module chunks = 3 6